import { render, staticRenderFns } from "./FormDatepickerVariant.vue?vue&type=template&id=0056b574&"
import script from "./FormDatepickerVariant.vue?vue&type=script&lang=js&"
export * from "./FormDatepickerVariant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports